export const snackbarTypes = {
  error: "error",
  warning: "warning",
  info: "info",
  success: "success",
};
